<script lang="ts" setup>
import { getConfigData } from "../api";
import CusPopup from "./CusPopup.vue";
import { useGlobalData } from "@/utils/useGlobal";
import { reactive } from "vue";
import { copy } from "@/utils/copy";
import { toast } from "@/utils/global";

const { showGiftBag, config } = useGlobalData();

const giftCode: { info: IGiftCodeData } = reactive({
  info: {
    instructions: "",
    code: "",
    method: "",
    giftPack: [],
  },
});
async function getGiftConfig() {
  try {
    let res = await getConfigData<IGiftCodeData>("gift-pack");
    if (res.length && res[0]) {
      giftCode.info = res[0];
    }
  } catch (e) {
    console.log("getGiftConfig error", e);
  }
}
getGiftConfig();

function copyCode(val: string) {
  if (!val) return;
  copy(val);
  toast("复制成功");
}
</script>
<template>
  <CusPopup v-if="showGiftBag" @close="showGiftBag = false">
    <div class="gift-code">
      <div class="gift-code-left">
        <div class="gift-wx">
          <img :src="config.socialMedia.weixin" alt="微信" class="gift-qr" />
        </div>
        <div>{{ config.socialMedia.weixinDesc }}</div>
      </div>
      <div class="line"></div>
      <div class="gift-code-right">
        <h3 class="gift-right-title">神祝礼包</h3>
        <ul class="gift-code-imgs">
          <li
            v-for="item in giftCode.info.giftPack"
            :key="item.imgUrl"
            class="gift-code-imgs-item"
          >
            <img :src="item.imgUrl" alt="礼包" class="img" />
          </li>
        </ul>
        <div class="code" @click="copyCode(giftCode.info.code)">
          {{ giftCode.info.code }}
        </div>
        <div class="gift-method">
          <p class="msg">使用方法：</p>
          <p>{{ giftCode.info.method }}</p>
        </div>
        <div class="gift-notice">
          <p class="msg">使用须知：</p>
          <p>{{ giftCode.info.instructions }}</p>
        </div>
      </div>
    </div>
  </CusPopup>
</template>

<style lang="less" scoped>
.gift-code {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6.26rem;
  background: url("~/images/gift-code/bg.png") no-repeat 0 0 / 100% 100%;
}
.gift-code-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 6rem;
  color: #f7e5cb;
  .gift-wx {
    width: 2.32rem;
    height: 2.32rem;
    padding: 0.12rem;
    margin-bottom: 0.35rem;
    background-color: #94684a;
    border: 0.01rem solid #6c4327;
    border-radius: 0.1rem;
    & > img {
      width: 100%;
    }
  }
}
.gift-code-right {
  font-size: 0.18rem;
  color: #563620;
  .gift-right-title {
    width: 3.75rem;
    height: 0.54rem;
    text-indent: -9999rem;
    background: url("~/images/gift-code/title.png") no-repeat 0 0 / cover;
  }
  .gift-code-imgs {
    display: flex;
    justify-content: center;
    margin-top: 0.2rem;
  }
  .gift-code-imgs-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.38rem;
    height: 1.34rem;
    background: url("~/images/gift-code/img-bg.png") no-repeat 0 0 / cover;
    & > img {
      width: 80%;
    }
  }
  .code {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.12rem;
    height: 0.69rem;
    margin: 0.18rem auto 0;
    font-size: 0.18rem;
    color: #795034;
    cursor: pointer;
    background: url("~/images/gift-code/code-bg.png") no-repeat 0 0 / cover;
    &::after {
      display: inline-block;
      padding: 0.1rem 0.14rem;
      margin-left: 0.1rem;
      color: #f7e5cb;
      content: "复制礼包码";
      background-color: #9a6e4e;
      border-radius: 0.1rem;
    }
  }
  .msg {
    line-height: 1;
  }
  .gift-notice,
  .gift-method {
    line-height: 1.4;
  }
}

.pc {
  .line {
    width: 0.05rem;
    height: 4.21rem;
    margin: 0 0.44rem 0 0;
    background: url("~/images/gift-code/line.png") no-repeat 0 0 / cover;
  }
  .gift-code {
    width: 10.16rem;
    height: 6.26rem;
    padding: 0 0.7rem;
  }
  .gift-code-left {
    font-size: 0.26rem;
  }
  .gift-notice {
    margin-top: 0.3rem;
  }
  .gift-method {
    margin-top: 0.18rem;
  }
  .msg {
    margin-bottom: 0.18rem;
    font-size: 0.24rem;
  }
}

.wap {
  .gift-code {
    // flex-direction: column;
    width: 7.5rem;
    padding: 0 0.4rem 0 0.3rem;
    // height: 8rem;
  }
  .gift-code-left {
    font-size: 0.24rem;
    .gift-wx {
      width: 2rem;
      height: 2rem;
    }
  }
  .gift-code-right {
    margin-left: 0.2rem;
    font-size: 0.22rem;
  }
  .gift-notice {
    margin-top: 0.2rem;
  }
  .gift-method {
    margin-top: 0.1rem;
  }
  .msg {
    margin-bottom: 0.1rem;
    font-size: 0.26rem;
  }
  .line {
    display: none;
  }
}
</style>
